import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let renewing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status !== 401 || !cfg || cfg._retry || cfg.url.startsWith("/auth/")) throw err;
    cfg._retry = true;
    renewing = renewing || api.post("/auth/refresh").finally(() => setTimeout(() => (renewing = null), 0));
    await renewing;
    return api(cfg);
  }
);

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
}

export function useResource(path) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    const r = await api.get(path);
    setData(r.data);
    setLoading(false);
  }, [path]);
  useEffect(() => {
    reload();
  }, [reload]);
  const replace = useCallback((doc) => setData((d) => d.map((x) => (x.id === doc.id ? doc : x))), []);
  return { data, setData, loading, reload, replace };
}

export const COLORS = {
  terracotta: "rgb(var(--t-primary))",
  sage: "rgb(var(--t-c2))",
  amber: "rgb(var(--t-c3))",
  walnut: "rgb(var(--t-c4))",
  lavender: "rgb(var(--t-c5))",
};

export const NOTE_COLORS = {
  oat: "rgb(var(--t-note-plain))",
  sage: "rgb(var(--t-c2-soft))",
  clay: "rgb(var(--t-primary-soft))",
  honey: "rgb(var(--t-c3-soft))",
  lavender: "rgb(var(--t-c5-soft))",
};

export const safeUrl = (u) => (u && /^https?:\/\//i.test(u) ? u : undefined);
export const safeImg = (u) => (u && /^https:\/\//i.test(u) ? u : undefined);

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "AUD" }).format(n || 0);
